module.exports = __webpack_public_path__ + "img/clogo.54daaa0e.png";